.bottom-sheet {
  position: fixed;
  inset: auto 0 0 0;
  margin: 0;
  border: none;
  width: 100%;
  max-width: 100%;
  background: #fff;
  border-radius: 20px 20px 0 0;
  padding: theme.token('space.600');
  padding-top: theme.token('space.400');
  max-height: 80vh;
  overflow-y: auto;
  transform: translateY(100%);
  transition:
    transform 0.3s ease-out,
    overlay 0.3s ease-out allow-discrete,
    display 0.3s ease-out allow-discrete;

  &[open] {
    transform: translateY(0);
  }

  @starting-style {
    &[open] {
      transform: translateY(100%);
    }
  }

  &--dragging {
    transition: none;
  }

  &::backdrop {
    background: rgba(0, 0, 0, 0);
    transition:
      background 0.3s ease-out,
      overlay 0.3s ease-out allow-discrete,
      display 0.3s ease-out allow-discrete;
  }

  &[open]::backdrop {
    background: rgba(0, 0, 0, 0.5);
  }

  @starting-style {
    &[open]::backdrop {
      background: rgba(0, 0, 0, 0);
    }
  }

  &__handle-zone {
    cursor: grab;
    touch-action: none;
    padding: theme.token('space.200') 0;
  }

  &__handle {
    width: 40px;
    height: 4px;
    background: #d9d9d9;
    border-radius: 2px;
    margin: 0 auto theme.token('space.400');
  }

  &__content {
    display: flex;
    flex-direction: column;
    gap: theme.token('space.600');
  }
}

// The global reduce rule in main.scss targets *, *::before and *::after, which never match ::backdrop.
@media (prefers-reduced-motion: reduce) {
  .bottom-sheet::backdrop {
    transition-duration: 0.01ms;
  }
}
